














import Vue from 'vue'
import Component from 'vue-class-component'
import HttpError from '@/shared/components/http-error.vue'
import RespondecoHeader from '@/main/header/header.vue'
import RespondecoFooter from '@/main/footer.vue'

@Component({
  components: { RespondecoFooter, RespondecoHeader, HttpError },
})
export default class Respondeco404 extends Vue {}
